export default __webpack_public_path__ + "static/media/blizzlau.290f529f.png";